module.exports = __webpack_public_path__ + "static/img/pixels-footer-logo.2f0d55f.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/pixels-footer-logo.png
// module id = vJih
// module chunks = 1